import React from 'react';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import styles from './styles/about-02.module.css';

import {ReactComponent as EqualImg} from '../../assets/about02/equal.svg';
import {ReactComponent as PlusImg} from '../../assets/about02/plus.svg';
import { div } from 'framer-motion/client';

export default function About02() {
    const mobileSmall = useMediaQuery('(max-width: 480px)');
    const mobileMedium = useMediaQuery('(min-width: 481px) and (max-width: 768px)');
    const mobileLarge = useMediaQuery('(min-width: 769px) and (max-width: 1024px)');

    const getText = () => {
        if(mobileSmall || mobileMedium) return <div>데이터 인프라와 AI 전문 인력이 부족한 기업들도 AI를 통해<br />혁신을 이루고 지속 가능한 성장을 달성할 수 있도록 지원합니다</div>;
        if(mobileLarge) return <div>데이터 인프라와 AI 전문 인력이<br />부족한 기업들도 AI를 통해 혁신<br />을 이루고 지속 가능한 성장을<br />달성할 수 있도록 지원합니다</div>;
        
        return <div>데이터 인프라와 AI 전문 인력이 부족한 기업들도 AI를 통해<br />혁신을 이루고 지속 가능한 성장을 달성할 수 있도록 지원합니다</div>;
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <p className={styles.title}>명확함은 무한한 가능성을 이끕니다</p>
                <div className={styles.boxSlogan}>
                    <div className={styles.boxFormula}>
                        <p>Definite</p>
                        <PlusImg />
                        <p>Infinite</p>
                        <EqualImg />
                        <p>Dfinite</p>
                    </div>
                    {getText()}
                </div>
            </div>
        </div>
    );
}
